import { z } from "zod";
import { JobStatusSchema } from "../../enums/core";

export const JobStatusValueSchema = JobStatusSchema;
export type JobStatusValue = z.infer<typeof JobStatusValueSchema>;

export const CreateJobResponseSchema = z.object({
  jobs: z.array(
    z.object({
      jobId: z.uuid(),
      websiteId: z.uuid(),
      status: JobStatusValueSchema,
    }),
  ),
});

export type CreateJobResponse = z.infer<typeof CreateJobResponseSchema>;

export const JobImportResponseSchema = z.object({
  jobs: z.array(
    z.object({
      jobId: z.uuid(),
      websiteId: z.uuid(),
      status: JobStatusValueSchema,
    }),
  ),
});

export type JobImportResponse = z.infer<typeof JobImportResponseSchema>;

export const JobStatusResponseSchema = z.object({
  jobId: z.uuid(),
  websiteId: z.uuid(),
  status: JobStatusValueSchema,
  error: z.string().nullable(),
  pageCount: z.number().int(),
  report: z.unknown().nullable(),
  createdAt: z.iso.datetime(),
  startedAt: z.iso.datetime().nullable(),
  finishedAt: z.iso.datetime().nullable(),
});

export type JobStatusResponse = z.infer<typeof JobStatusResponseSchema>;
